import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { persistStore } from 'redux-persist';
import { applyMiddleware, compose, createStore } from 'redux';
import axios from 'config/axios';
import createAxiosMiddleware from 'middleware/axios';

export const history = createBrowserHistory();

/**
 * Create store instance
 *
 * @return {Promise<Object>}
 */
async function configureStore() {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [
    thunk,
    createAxiosMiddleware(axios),
    routerMiddleware(history),
  ];

  const store = createStore(() => {},
  composeEnhancers(applyMiddleware(...middlewares)));

  const persist = await persistStore(store);

  return { store, persist };
}

export default configureStore;
